export default "__VITE_ASSET__D565A31H__"